/**=========================================================
 * Module: upload-picture.js
 * Upload Picture Controller
 =========================================================*/

App.controller('UploadPictureController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$sce', '$element', 'ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $sce, $element, ngDialog) {
    "use strict";
    
    $scope.fileUploadList = [];  

    $scope.fileId = $scope.field.name + '_' + ($scope.form.model.id || $scope.form.model.tempId);
    $scope.t = new Date().getTime();
    $scope.uploaded = false;
    $scope.allowString = ($scope.field.allow || '').replace(/\|/g, ', ');
    $scope.targetField = $scope.field.srcField || $scope.field.targetField || 'picture';
      
    
    $scope.uploadedFile = function(data){
        D.save('file', { 
            entityType: data.entityType, 
            entityId: data.entityId, 
            field: data.field,
            type: data.type,
            size: data.size,
            bucket: data.bucket,
            url: data.bucket + '/' + data.url,
            public: true
        }).then(function(){
            $timeout(function(){$scope.refresh(false, true);},200);
        }).catch(console.error)
    }
         
    
    $scope.removeFile = function(index){
        var file = $scope.fileUploadList[index];
        ngDialog.openConfirm({
                  template: 'confirmRemoveFileDialog',
                  className: 'ngdialog-theme-default'
                })
        .then(function (value) {
                D.remove('file', file.id).then(
                    function(){
                        $scope.fileUploadList.splice(index, 1);
                        var jsonData = {}
                        var defaultPictures = {
                            account: 'https://app.aqrate.biz/app/images/user.png',
                            group: 'https://app.aqrate.biz/app/images/group.png'
                        }
                        jsonData[$scope.targetField] = defaultPictures[$scope.form.type];
                        if($scope.form.model.id){
                            R.one($scope.form.type, $scope.form.model.id).put({ jsonData: jsonData })
                                .then(function(resp){
                                    $scope.form.model[$scope.targetField]=resp[$scope.targetField];
                                })
                        }
                    }
                ).catch(console.error);
            }, function (reason) {
                
            });
    };  
      
    $scope.refresh = function(retry){
        D.query('file', 'type=' + $scope.form.type + '&field=' + $scope.field.name + '&entityId=' + $scope.form.model.id, { cache: false }).then(
                function(response){
                	
                	
                	
                    $scope.fileUploadList = response;
                    
                    if(!$scope.$parent.$parent.files){
                        $scope.$parent.$parent.files = {};
                    }
                    $scope.$parent.$parent.files[$scope.field.name] = response;
                    
                    if(response[0]){
                    if(response[0].url){
	                    if($scope.form.model[$scope.targetField]==response[0].url){
	                		//Se user picture attuale è uguale alla picture presente nel file upload
	                	}else{
	                		var fileToDel = $scope.fileUploadList[1];
	                		if(fileToDel){
		                    	D.remove('file', fileToDel.id);
		                    	$scope.form.model[$scope.targetField]=response[0].url;
		                    	
		                    	$scope.fileUploadList = response;
		                        
		                        if(!$scope.$parent.$parent.files){
		                            $scope.$parent.$parent.files = {};
		                        }
		                        $scope.$parent.$parent.files[$scope.field.name] = response;
	                		}else{
	                			$scope.form.model[$scope.targetField]=response[0].url;
                            }
                            var jsonData = {};
                            jsonData[$scope.targetField] = response[0].url; 
                            if($scope.form.model.id){
                                R.one($scope.form.type, $scope.form.model.id).put({ jsonData: jsonData })
                            }
	                	}
                    }
                    }
                    if(retry)
                        $timeout($scope.refresh, 2000);
                    
                    /*$scope.safeApply = function(fn) {
                        var phase = $rootScope.$$phase;
                        if(phase == '$apply' || phase == '$digest') {
                            if(fn && (typeof(fn) === 'function')) {
                            fn();
                            }
                        } else {
                            this.$apply(fn);
                        }
                        };
                    var fn = function(){};
                    $scope.safeApply(fn);
                    $timeout(function(){$scope.safeApply(fn);},1000);*/
    
                }
                
            ).catch(function(error){
                    //$scope.error = error;
                    if(retry)
                        $timeout($scope.refresh, 2000);
                });
    };  
    $scope.refresh();
      
  }
  ]);